/**
 * Queture Test Page (Company App Wrapper)
 *
 * @quebon/shared-learning의 QuetureTestPage 공통 컴포넌트를 사용.
 * Company 앱의 content API와 quiz API를 주입. i18n 번역 함수 전달.
 */
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { QuetureTestPage as SharedQuetureTestPage } from '@quebon/shared-learning'
import type { QuetureTestApi, QuetureTestToonApi, PauseAndGoType } from '@quebon/shared-learning'
import { contentApi } from '@/api/content'
import { quizScriptApi } from '@/api/quizScript'

export default function QuetureTestPage() {
  const { t } = useTranslation('learner')

  const quetureTestApi = useMemo<QuetureTestApi>(() => ({
    getQuetureInfo: async (quetureId: string, includeUnpublishedPauseAndGo = false) => {
      const res = await contentApi.getQuetureInfo(0, quetureId, includeUnpublishedPauseAndGo)
      return {
        quetureId: res.quetureId,
        title: res.title ?? undefined,
        hlsUrl: res.hlsUrl ?? undefined,
        summaryHlsUrl: res.summaryHlsUrl ?? undefined,
        thumbnailUrl: res.thumbnailUrl ?? undefined,
        duration: res.duration ?? undefined,
        hasSummary: res.hasSummary ?? false,
        pauseAndGos: (res.pauseAndGos ?? []).map((p) => ({
          id: p.id,
          time: p.time,
          type: p.type as PauseAndGoType,
          published: p.published,
          whenToGo: p.whenToGo ?? undefined,
          whenToGoBack: p.whenToGoBack ?? undefined,
          bundleItem: p.bundleItem ?? undefined,
          okButtonMessage: p.okButtonMessage ?? undefined,
          notOkButtonMessage: p.notOkButtonMessage ?? undefined,
          msg: p.msg ?? undefined,
          pauseDuration: p.pauseDuration ?? undefined,
          quizId: p.quizId ?? undefined,
          videoKey: p.videoKey ?? undefined,
        })),
      }
    },
    quizApi: {
      getQuiz: quizScriptApi.getQuiz,
      solve: quizScriptApi.solve,
    },
  }), [])

  const toonApi = useMemo<QuetureTestToonApi>(() => ({
    getQuetureContent: contentApi.getQuetureContent,
  }), [])

  return <SharedQuetureTestPage api={quetureTestApi} toonApi={toonApi} t={t} />
}
